import Modal from '../../components/Modal';

import SelectorEngine from '../../utils/dom/selector-engine';

import Request from  '../../utils/request';
import AddressSearch from '../../components/AddressSearch';
class AccountDetailsAddress {
	constructor() {
		this._wrapper = undefined;
		this._exitModal = undefined;
		this._hasUnsavedChanges = false;
		this._errorWrapper = undefined;
		this._backButton = undefined;

		this._saveCta = undefined;
		this._exitCta = undefined;

		this.initiatePage();
	}

	initiatePage() {
		this._wrapper = SelectorEngine.findOne('.p-account-details__address');

		if (this._wrapper !== null) {
			this._exitModal = new Modal(SelectorEngine.findOne('#exit-editing'), {});
			this._wrapper.addEventListener('change', (event) => this.showSave(event));

			this._backButton = SelectorEngine.findOne('.js-account-edit-back');
			this._backButton.addEventListener('click', (event) => {
				this.exitEditing(event);
			});

			this._exitCta = SelectorEngine.findOne('.js-account-exit', this._wrapper);
			this._exitCta.addEventListener('click', (event) => {
				this.exitEditing(event);
			});

			this._errorWrapper = SelectorEngine.findOne('.p-account-details__submission-error');
			const errorCloseCta = SelectorEngine.findOne('.js-dismiss-account-submission--error', this._errorWrapper);
			errorCloseCta.addEventListener('click', () => {
				this._errorWrapper.classList.add('u-hidden');
			})

			const popupCancel = SelectorEngine.findOne('.js-account-details-continue');
			popupCancel.addEventListener('click', () => this._exitModal.hide());

			const popupContinue = SelectorEngine.findOne('.js-account-details-exit');
			popupContinue.addEventListener('click', (event) => this.backToUrl(event));

			this._saveCta = SelectorEngine.findOne('.js-account-save-address', this._wrapper);
			this._saveCta.addEventListener('click', (event) => this.submitForm(event));

			const addressForm = SelectorEngine.findOne('.js-retrive-address', this._wrapper);
			this._addressSearch = AddressSearch.getOrCreateInstance(addressForm);
		}
	}

	showSave(event) {
		const saveButton = SelectorEngine.findOne('.js-account-save-address', this._wrapper);
		if (event.detail && !event.detail.existing) {
			saveButton.classList.remove('u-hidden');
			this._hasUnsavedChanges = true;
		} else {
			saveButton.classList.add('u-hidden');
			this._hasUnsavedChanges = false;
		}
	}

	exitEditing(event) {
		if (this._hasUnsavedChanges) {
			this._exitModal.show()
		} else {
			this.backToUrl(event);
		}
	}

	backToUrl(event, eventUrl = null) {
		const rootUrl = window.location.origin
		const url = eventUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	async submitForm(event) {

		// Validate address before saving
		const isValidAddress = await this._addressSearch.validate();
		if(isValidAddress !== 'Valid') {
			return;
		}

		this._saveCta.disabled = true;
		this._exitCta.disabled = true;
		const { target } = event.currentTarget.dataset;
		const addressForm = SelectorEngine.findOne('.js-edit-address', this._wrapper);
		const formData = new FormData(addressForm);
		const dataObject = {};
		formData.forEach((value, key) => {
			dataObject[key] = value;
		});
		const submitted = await Request.post('/api/account/personal', {
			address: dataObject
		})
			.catch(() => {
				this._errorWrapper.classList.remove('u-hidden');
				this._saveCta.disabled = false;
				this._exitCta.disabled = false;
			});
		if (submitted) {
			this.backToUrl(null, target);
		}
	}
}

const globalAccountDetailsAddress = new AccountDetailsAddress();

export default globalAccountDetailsAddress;


